<div class="filter-input-wrapper">
  <mat-form-field>
    <input
      autocomplete="off"
      matInput
      type="text"
      #input
      [placeholder]="placeholder"
      [formControl]="termControl"
      (keydown)="$event.stopPropagation()"
      (input)="onSearchTermChanged()">
    <mat-icon matSuffix (click)="clearTerm()">{{ termControl.value ? 'close' : 'search' }}</mat-icon>
  </mat-form-field>
  <div class="checkbox-wrapper clearfix">
    <div class="select-all" *ngIf="matSelect.multiple && isSelectAll"
      [matTooltip]="!selectAllEnable ? 'Hay demasiados items para ser seleccionados' : ''" [matTooltipPosition]="'right'"
      matTooltipClass="exa-tooltip filter">
      <mat-checkbox
        color="primary"
        (change)="onSelectAll($event)"
        [checked]="isSelectAll"
        [disabled]="!filteredCollectionLength || !selectAllEnable">
        <span>Seleccionar todo</span>
      </mat-checkbox>
    </div>
    <div class="text-center selected-count" *ngIf="matSelect.multiple">
      <!-- <span *ngIf="!selected.length"> Selected</span> -->
      <span *ngIf="selected.length && selected.length < collection.length">{{ selected.length }} seleccionados de {{ collection.length }}</span>
      <!-- <span *ngIf="selected.length && selected.length === collection.length">Seleccionados</span> -->
    </div>
    <div class="text-right show-selected-only" *ngIf="showSelectedOnly">
      <mat-checkbox color="primary" (change)="onCheckboxChange($event)" [checked]="showSelected"
        [disabled]="!filteredCollectionLength || !selected.length || (isSelectAll && !showSelected)">
        <span>Mostrar seleccionados</span>
      </mat-checkbox>
    </div>
  </div>
</div>